import { useCallback } from 'react';

interface ErrorInfo {
  message: string;
  errorCode: string;
  error: Error | string | unknown;
}

/**
 * Hook for error logging that works both inside and outside Router context
 */
const useError = () => {
  const sendErrorLog = useCallback((errorInfo: ErrorInfo) => {
    const { error, errorCode, message } = errorInfo;

    const errorLogData = {
      source: 'frontend',
      currentPage: window.location.pathname,
      userAgent: navigator.userAgent,
      error:
        typeof error === 'string'
          ? error
          : error instanceof Error
            ? JSON.stringify(error, Object.getOwnPropertyNames(error))
            : typeof error === 'object' && error !== null
              ? JSON.stringify(error)
              : `${error}`,
      errorCode,
      message,
      timestamp: new Date().toISOString(),
    };

    console.error('Error Log:', errorLogData);

    // TODO: Error logging API
  }, []);

  return { sendErrorLog };
};

export default useError;
